<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">房型头图</h3>
      <div>
        <img class="imgwidth" v-if="headImg"  :src="headImg"/>
        <Upload class="upload"
                :action="baseUrl+'/file/uploadFile'"
                :on-success="handleSuccess"
                :headers="{'Access-Token':token}"
                :show-upload-list="false"
                :on-error="handleError"
                :format="['jpg','jpeg','png']"
                :on-format-error="handleFormatError"
        >
          <Icon type="ios-plus-empty" size="40" style="vertical-align: middle"></Icon>
        </Upload>
      </div>
    </Modal>
  </div>

</template>

<script>
  import {houseTypeConfig} from "api/houseTypeConfig";
  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";

  export default {
    name: "HeadImg",
    props:{
      img:{
        type:String,
        default:''

      },
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        // this.headImga=''
        // this.getProjectConfigInfo()
        this.isShow=true
      },
      img(val) {
        this.headImg = val
      }

    },
    data(){
      return {
        isShow:false,
        token: '',
        baseUrl: '',
headImg:'',
        loading:true
      }
    },
    methods:{
      ok(){
        this.houseTypeConfig()

      },
      handleError(){

      },
      handleFormatError() {
      this.$Message.error('请输入jpg,jpeg,png,格式的文件')
    },
    changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      handleSuccess(response){
        this.headImg = response.data.url
      },
      houseTypeConfig(){
        if(!this.fid || !this.headImg){
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false
          return
        }
        let data = {
          fid: this.fid,
          headImg: this.headImg
        }
        houseTypeConfig(data).then(res=>{
          this.$Message.success('房型头图配置成功')
          this.changeLoading()
          this.$emit('refresh')
          this.isShow = false
       
        })
      }
    },
    created(){
      // this.getProjectConfigInfo()
      this.baseUrl = getBaseUrl()
      this.token = getToken()
    }

  }
</script>

<style scoped>
  .imgwidth{
    width: 150px;
    height: 100px;
    vertical-align: middle;
  }
  .upload {
    display: inline-block;
    width: 150px;
    height: 100px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 100px;
    vertical-align: middle;
  }

</style>
